/**
 * Flight input form component
 * Single itinerary input — origin/destination/duration auto-calculated
 */

import React from 'react';
import { View, Text, TextInput, StyleSheet } from 'react-native';
import { useFlightStore } from '../store';

const ACCENT_CYAN = '#00b8d9';

export function FlightInputForm() {
  const { currentFlight, itinerary, setItinerary, setDate } = useFlightStore();

  return (
    <View style={styles.container}>
      <TextInput
        style={styles.input}
        placeholder="Flight itinerary (e.g. JFK to LHR, New York to London)"
        value={itinerary}
        onChangeText={setItinerary}
      />
      <Text style={styles.hint}>
        City names or airport codes. Duration auto-calculated.
      </Text>
      {currentFlight.origin && currentFlight.destination && (
        <Text style={[styles.hint, styles.parsed]}>
          {currentFlight.origin} → {currentFlight.destination} • {currentFlight.durationMinutes} min
        </Text>
      )}
      <TextInput
        style={styles.input}
        placeholder="Date (YYYY-MM-DD)"
        value={currentFlight.date ?? ''}
        onChangeText={setDate}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: { gap: 12 },
  input: {
    borderWidth: 1,
    borderColor: '#ccc',
    padding: 12,
    borderRadius: 8,
  },
  hint: { fontSize: 11, color: '#64748b', marginTop: -8 },
  parsed: { color: ACCENT_CYAN, fontWeight: '600' },
});
